/**
 * @file  Governance
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React from 'react';
import {Navigation} from '@yunying/crow';
// eslint-disable-next-line import/extensions
import routes from '~/route.config';

import './index.less';


function Governance(props) {
    const {children} = props;

    return (
        <div className="governance-container">
            <Navigation dataSource={
                routes[0].subRoutes.find(item => item.name === 'governance').subRoutes.map((item, index) => ({
                    title: item.title,
                    key: index,
                    path: `/governance/${item.path}`
                }))
            }
            />
            {children}
        </div>
    );
}

export default Governance;
